/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  today: 'Danas',
  now: 'Sad',
  backToToday: 'Natrag na danas',
  ok: 'Ok',
  clear: 'OÄisti',
  month: 'Mjesec',
  year: 'Godina',
  timeSelect: 'odaberite vrijeme',
  dateSelect: 'odaberite datum',
  weekSelect: 'Odaberite tjedan',
  monthSelect: 'Odaberite mjesec',
  yearSelect: 'Odaberite godinu',
  decadeSelect: 'Odaberite desetljeÄe',
  yearFormat: 'YYYY',
  dateFormat: 'D.M.YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'D.M.YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'ProÅ¡li mjesec (PageUp)',
  nextMonth: 'SljedeÄi mjesec (PageDown)',
  previousYear: 'ProÅ¡la godina (Control + left)',
  nextYear: 'SljedeÄa godina (Control + right)',
  previousDecade: 'ProÅ¡lo desetljeÄe',
  nextDecade: 'SljedeÄe desetljeÄe',
  previousCentury: 'ProÅ¡lo stoljeÄe',
  nextCentury: 'SljedeÄe stoljeÄe'
};
